import createEnum from 'enumpup';

export const GameActions = createEnum(
    'ADD_VOWEL',
    'ADVANCE_FOR_SURVIVAL',
    'APPEND_TO_WORD',
    'ATTACK_DRAIN',
    'BLANK_LETTER',
    'BLANK_VOWEL',
    'CHANGE_ENERGY',
    'CLEAR',
    'CLEAR_WORD',
    'COMPRESS_VOWELS',
    'GO',
    'NEW_GAME',
    'NEW_LETTERS',
    'PLAYER_DEFEATED',
    'RESTORE',
    'RESTORE_LETTER',
    'RESTORE_VOWEL',
    'SET_BEST_WORDS',
    'TAKE_LETTER',
    'TAKE_VOWEL',
    'TURN',
    'UPDATE',
    'UPDATE_BEST_WORDS',
    'UPDATE_WORD',
    'VOWEL',
    'WIN',
    'WIPE_WORD',
);

export function addVowel(vowel) {
  return {type: GameActions.ADD_VOWEL, payload: {vowel}};
}

export function advanceForSurvival() {
  return {type: GameActions.ADVANCE_FOR_SURVIVAL};
}

/**
 * The action to update the word array.
 * @param {array} letterInfo
 * @return {action} UPDATE_WORD action
 */
export function appendToWord(letterInfo) {
  return {type: GameActions.APPEND_TO_WORD, payload: {letterInfo}};
}

/**
 * The action to perform a drain attack.
 * @param {number} drainAmount
 * @return {action} ATTACK_DRAIN action
 */
export function attackDrain(drainAmount) {
  return {type: GameActions.ATTACK_DRAIN, payload: {drainAmount}};
}

/**
 * The action to blank a letter in the letter box.
 * @param {number} index
 * @return {action} BLANK_LETTER action
 */
export function blankLetter(index) {
  return {type: GameActions.BLANK_LETTER, payload: {index}};
}

/**
 * The action to blank a vowel in the vowel pool.
 * @param {number} index
 * @return {action} BLANK_VOWEL action
 */
export function blankVowel(index) {
  return {type: GameActions.BLANK_VOWEL, payload: {index}};
}

export function changeEnergy(newEnergy) {
  return {type: GameActions.CHANGE_ENERGY, payload: {newEnergy}};
}

/**
 * The action to clear the current word.
 * @return {action} CLEAR action.
 */
export function clear() {
  return {type: GameActions.CLEAR};
}

/**
 * The action of playing a word in the game.
 *
 * @return {action} GO action
 */
export function go() {
  return {type: GameActions.GO};
}

/**
 * The action to restore a letter to either the letter box or vowel pool.
 * @param {number} wordIndex
 * @param {object} letterInfo
 * @return {action} RESTORE action.
 */
export function restore(wordIndex, letterInfo) {
  return {type: GameActions.RESTORE, payload: {wordIndex, letterInfo}};
}

/**
 * The action to restore a letter back to the letter box.
 *
 * @param {object} letterInfo
 * @return {action} RESTORE_LETTER action.
 */
export function restoreLetter(letterInfo) {
  return {type: GameActions.RESTORE_LETTER, payload: {letterInfo}};
}

/**
 * The action to restore a vowel back to the vowel pool.
 * @param {object} letterInfo
 * @return {action} RESTORE_VOWEL action.
 */
export function restoreVowel(letterInfo) {
  return {type: GameActions.RESTORE_VOWEL, payload: {letterInfo}};
}

/**
 * The action of taking a letter from the letter box.
 * @param {number} index
 * @return {action} TAKE_LETTER action.
 */
export function takeLetter(index) {
  return {type: GameActions.TAKE_LETTER, payload: {index}};
}

/**
 * The action of taking a letter form the vowel pool.
 * @param {number} index
 * @return {action} TAKE_VOWEL action.
 */
export function takeVowel(index) {
  return {type: GameActions.TAKE_VOWEL, payload: {index}};
}

export function update(updates) {
  return {type: GameActions.UPDATE, payload: {updates}};
}

export function win() {
  return {type: GameActions.WIN};
}

/**
 * The action to add a new vowel.
 * @return {action} VOWEL action.
 */
export function vowel() {
  return {type: GameActions.VOWEL};
}

/**
 * The action to populate the letter box with new letters.
 * @return {action} NEW_LETTERS
 */
export function newLetters() {
  return {type: GameActions.NEW_LETTERS};
}

/**
 * The action to start a new game.
 * @return {action} NEW_GAME
 */
export function newGame() {
  return {type: GameActions.NEW_GAME};
}

/**
 * The action to update the best words.
 * @param {array} newBestWords
 * @return {action} SET_BEST_WORDS action
 */
export function setBestWords(newBestWords) {
  return {type: GameActions.SET_BEST_WORDS, payload: {newBestWords}};
}

export function turn(health) {
  return {type: GameActions.TURN, payload: {health}};
}

/**
 * The action of the player being defeated
 * @return {action} PLAYER_DEFEATED action
 */
export function playerDefeated() {
  return {type: GameActions.PLAYER_DEFEATED};
}

export function updateWord(word) {
  return {type: GameActions.UPDATE_WORD, payload: {word}};
}

export function compressVowels() {
  return {type: GameActions.COMPRESS_VOWELS};
}

export function clearWord() {
  return {type: GameActions.CLEAR_WORD};
}

export function wipeWord() {
  return {type: GameActions.WIPE_WORD};
}
